(function() { window.GUID_c03a0523_0c45_4094_ac31_2f1da78169f9 = { getGuid: function() { return "c03a0523-0c45-4094-ac31-2f1da78169f9"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatLayout;
        (function (StatLayout) {
            StatLayout[StatLayout["Cards"] = 0] = "Cards";
            StatLayout[StatLayout["Grid"] = 1] = "Grid";
        })(StatLayout = Enumeration.StatLayout || (Enumeration.StatLayout = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatLayout.pre.js.map
